import React from "react";

const Java_Public = () => {
  return (
    <div>
      <h1>Java Public</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Public in Java.</p>
    </div>
  );
};

export default Java_Public;
